import React from 'react';
import { Container, Row } from 'reactstrap';
import UploadType from './UploadType';
import UploadInstructions from './UploadInstructions';
import Dropzone from './Dropzone';
import StatusTile from './Status';

function BatchUploadPage({
  input,
  previews,
  dropzoneProps,
  files,
}) {
  return (
    <Container fluid className={`custom-dropzone ${files.length > 0 ? 'loaded' : 'empty'}`}>
      <Row className="border border-light bg-white p-2 shadow-sm my-3 d-flex">
        <UploadType />
        <UploadInstructions />
        <Dropzone dropzoneProps={dropzoneProps} addFile={input} />
      </Row>
      <Row className="border border-light bg-white p-4 shadow-sm">
        <StatusTile fileCount={files.length} previews={previews} />
      </Row>
    </Container>
  );
}

export default BatchUploadPage;
